<template>
    <BarChart ref="barChartRef" :chartData="datasets" :options="options" />
</template>

<script>
import { parseToMoney } from "@/utils/currency";
import { getMonthsBetweenDates } from "@/utils/getMonthsBetweenDates";
import { getWeeksBetweenDates } from "@/utils/getWeeksBetweenDates";
import numberFormatter from "@/utils/numberFormatter.js";
import { computed, defineComponent, ref } from "@vue/composition-api";
import moment from "moment";
import { BarChart } from "vue-chart-3";
import formatData from "./formatChartData";

export default defineComponent({
    name: "ChartBankMovements",
    components: { BarChart },
    props: {
        startDate: {
            type: String,
            required: true,
        },
        endDate: {
            type: String,
            required: true,
        },
        chartData: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {
        const barChartRef = ref();
        function getLabelsList() {
            const datesAreInSameMonth = moment(props.startDate).isSame(
                props.endDate,
                "month"
            );
            if (datesAreInSameMonth) {
                return getWeeksBetweenDates(props.startDate, props.endDate);
            } else {
                return getMonthsBetweenDates(props.startDate, props.endDate);
            }
        }
        function getGroupedData() {
            const datesAreInSameMonth = moment(props.startDate).isSame(
                props.endDate,
                "month"
            );
            if (datesAreInSameMonth) {
                return formatData(props.chartData, getLabelsList(), false);
            } else {
                return formatData(props.chartData, getLabelsList(), true);
            }
        }
        const options = ref({
            maintainAspectRatio: false,
            responsive: true,
            scales: {
                xAxes: [
                    {
                        stacked: true,
                    },
                ],
                yAxes: [
                    {
                        stacked: true,
                        position: "right",
                        ticks: {
                            beginAtZero: true,
                            fontColor: "#272727",
                            fontFamily: "Open Sans",
                            callback: (value) => numberFormatter(value, 2),
                        },
                    },
                ],
            },
            tooltips: {
                enabled: true,
                callbacks: {
                    title: (tooltipItem) => {
                        return tooltipItem[0].xLabel;
                    },
                    label: (tooltipItem, data) => {
                        var label =
                            data.datasets[tooltipItem.datasetIndex].label || "";
                        return label + ": " + parseToMoney(tooltipItem.yLabel);
                    },
                    fontSize: 13,
                },
            },
        });
        const datasets = computed(() => ({
            labels: getLabelsList(),
            datasets: getGroupedData(),
        }));
        return { datasets, barChartRef, options };
    },
});
</script>
